export default class SocialMediaImageTemplate {
  constructor() {
    this.name = undefined;
    this.imageFilename = undefined;
    this.imageUrl = undefined;
    this.body = undefined;
    this.socialMediaId = undefined;
    this.contentTypeId = undefined;
    this.themeId = undefined;
    this.userTypeId = undefined;
    this.order = undefined;
  }

  loadData(payload) {
    this.name = payload.name;
    this.imageFilename = payload.imageFilename;
    this.imageUrl = payload.imageUrl;
    this.body = payload.body;
    this.socialMediaId = payload.socialMedia.id;
    this.contentTypeId = payload.contentType.id;
    this.themeId = payload.theme.id;
    this.userTypeId = payload.userType.id;
    this.order = payload.order;
  }
}
